itsoftApp.createModule("checkMenuLink", function () {
    var menuLinkElements = document.querySelectorAll(".main-menu__link");

    Array.prototype.forEach.call(menuLinkElements, function (el) {
        var href = el.href;

        if (el.pathname + el.hash === location.pathname && el.pathname !== "/") {
            var menuItem = el.parentNode;
            menuItem.classList.add("main-menu__item--current");
            el.removeAttribute("href");
        }
    })
});